import React from 'react';

import values  from '../../../../values';
import Context from '../../../../context';

import { useTranslation } from 'react-i18next';
import { BreadCrumb, CustomView, Pagination, ResponsiveView, TableHeader, TableLoading } from '../../../../components';

import CityComponents from './Components';

import './index.sass';
import {LOCATION_CITY_TABLE} from "../../../../values/tableHeaders";

type Props = {
  rqData: any;
};

const CityScreen: React.FC<Props> = (props: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { requestCity, setRequestCity } = React.useContext(Context.Location.City);
  const { t } = useTranslation();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <ResponsiveView.Container id='location-city-screen-wrapper'>
      <CustomView.Row className="table-options-wrapper">
        <CustomView.Column extraLarge={3} large={5} medium={5} className="bread-crumb-wrapper">
          <BreadCrumb />
        </CustomView.Column>
        <CustomView.Column extraLarge={4} large={5} medium={7} className="search-and-filter-wrapper">
          <CityComponents.Search />
          <CityComponents.Filter />
          <CityComponents.Create />
        </CustomView.Column>
      </CustomView.Row>
      <ResponsiveView.Container>
        <div className="table-content-wrapper">
          <table>
            <TableHeader headers={values.tableHeaders.LOCATION_CITY_TABLE.map((item) => t(item))}/>
            {props.rqData?.status === "loading" ? (<TableLoading />) : (<CityComponents.Body data={props.rqData} />)}
          </table>
        </div>
      </ResponsiveView.Container>
      {props.rqData?.status === 'success' &&
        props.rqData?.data?.result?.totalDocs > 10 && (
          <div className="pagination">
            <Pagination
              page={Number(requestCity?.page)}
              totalPages={props.rqData?.data?.result?.totalPages}
              onPaginate={(page: number) =>
                setRequestCity!({
                  ...requestCity,
                  page: page,
                })
              }
            />
          </div>
        )
      }
      <CityComponents.Update />
      <CityComponents.Delete />
    </ResponsiveView.Container>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
}

export default CityScreen;
